module.exports = __webpack_public_path__ + "static/media/select-dark.ae4898a8.svg";